export default "__VITE_ASSET__CULC1b2S__"